import { Box } from '@mantine/core';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { DRAWER_PADDING } from 'utils/general';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { PortalButton } from 'components/Button/PortalButton';
import { useAppContext, useDrawerContext } from 'context/hooks';

interface Props {
  queryKey: string;
  children: ReactElement | ReactElement[];
}

export const MoreFiltersDrawer = ({ queryKey, children }: Props) => {
  const { t } = useTranslation();
  const { resetParameters } = useSearchParameters(queryKey);
  const { openDrawer } = useDrawerContext();
  const { updateTableRowIds } = useAppContext();

  const handleResetAction = () => {
    resetParameters();
    updateTableRowIds?.([]);
  };

  return (
    <PortalButton
      onClick={() =>
        openDrawer({
          content: <Box px={DRAWER_PADDING}>{children}</Box>,
          actions: <PortalButton onClick={handleResetAction} label={t('reset_filters')} variant={'outline'} />,
          size: '40%',
        })
      }
      label={t('more_filters')}
    />
  );
};
